import { createContext } from 'react'

import { SettlementCreditLineType } from '@shared/graphql'

import type { SettlementCreditLine } from '@shared/graphql'

export interface SettlementCreditLineContextState {
  /**
   * Loading.
   */
  loading: boolean
  /**
   * Settlement credit line.
   */
  settlementCreditLine?: SettlementCreditLine
  /**
   * Settlement credit line.
   */
  settlementCreditLineType: SettlementCreditLineType
  /**
   * Translation key.
   */
  translationKey?: string
}

export const DEFAULT_VALUES = {
  loading: true,
  settlementCreditLineType: SettlementCreditLineType.settlementAdvance,
  translationKey: 'settlementAdvance',
}

export const SettlementCreditLineContext =
  createContext<SettlementCreditLineContextState>(DEFAULT_VALUES)
